import React from 'react';
import { TestimonialsSection } from './TestimonialsSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { VolumesSection } from './VolumesSection';
import { BonusesSection } from './BonusesSection';
import { OfferSection } from './OfferSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FaqSection } from './FaqSection';
import { FinalCtaSection } from './FinalCtaSection';
import { Footer } from './Footer';
import { StickyCta } from './StickyCta';

/**
 * Everything below the hero, bundled into a single lazy chunk. The first paint
 * only needs the urgency bar and the hero, which keeps the critical JS small.
 */
export function BelowFold() {
  return <>
      <main data-id="element-5" data-mp="dn8eht1144u1">
        <TestimonialsSection data-id="element-6" data-mp="dmoywiyupsj6" />
        <ProblemSection data-id="element-7" data-mp="3m3tguqz5nzo6" />
        <SolutionSection data-id="element-8" data-mp="3m31xqfmqvues" />
        <VolumesSection data-id="element-9" data-mp="3m28nv5shoosf" />
        <BonusesSection data-id="element-10" data-mp="3h59uwqkkanvt" />
        <OfferSection data-id="element-11" data-mp="3h61qi1e5slm3" />
        <GuaranteeSection data-id="element-12" data-mp="3h4gtm54dgql2" />
        <FaqSection data-id="element-13" data-mp="3h35qm7ir3mv0" />
        <FinalCtaSection data-id="element-14" data-mp="1kb6fdnnxztu" />
      </main>
      <Footer data-id="element-15" data-mp="1j9ul6ytp9b2" />
      <StickyCta data-id="element-16" data-mp="1jjjer84taf6" />
    </>;
}